export type ConnectionPoolConfig = {
  connection_limit: string;
  pool_timeout: string;
  connect_timeout: string;
  /**
   * Postgres `statement_timeout` in milliseconds, applied per connection.
   * Omit (or "0") for no cap, which is the primary pool's behavior.
   */
  statement_timeout_ms?: string;
};

export const CONNECTION_POOL_CONFIG: ConnectionPoolConfig = {
  connection_limit: "50",
  pool_timeout: "30",
  connect_timeout: "60",
};

/**
 * Pool for the read-only database. Deliberately small and time-boxed: only
 * internal dashboards read from it, and a runaway dashboard query must not be
 * able to starve the primary pool or hold a read-only connection open
 * indefinitely.
 */
export const READ_ONLY_CONNECTION_POOL_CONFIG: ConnectionPoolConfig = {
  connection_limit: "5",
  pool_timeout: "30",
  connect_timeout: "60",
  statement_timeout_ms: "30000",
};

// Local dev runs a single Next.js process against a single local Postgres
// instance, so the prod-sized pool is unnecessary and just reserves
// connections a local Postgres may not have to spare.
export const LOCAL_CONNECTION_POOL_CONFIG: ConnectionPoolConfig = {
  connection_limit: "5",
  pool_timeout: "30",
  connect_timeout: "60",
};
